export default "__VITE_ASSET__UeVjSrnQ__"